import { render, staticRenderFns } from "./Pin.vue?vue&type=template&id=5bc6c8a3&"
import script from "./Pin.vue?vue&type=script&lang=ts&"
export * from "./Pin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports